import React from "react";

export default function Loading() {
  return (
    <div className="bg-primary fixed inset-0 flex items-center justify-center bg-gradient-to-r from-purple-800 via-indigo-900 to-purple-800  animate-pulse">
      <div className="flex flex-col items-center space-y-6">
        {/* Glowing Spinner */}
        <div className="relative">
          <div className="w-24 h-24 border-4 border-dashed border-white rounded-full animate-spin"></div>
          <div className="absolute top-0 left-0 w-24 h-24 rounded-full bg-white opacity-10 blur-xl"></div>
        </div>

        {/* Loading Text */}
        <p className="text-white text-xl font-semibold tracking-wider animate-pulse">
          Loading, please wait...
        </p>
      </div>
    </div>
  );
}
